import GeneralStepBody from "./GeneralStepBody";
import ButtonAction from "../../../../components/buttons/ButtonAction";
import React from "react";
import routes from "../../../../Routes/routes";
import {IconSuccessResetPassword} from "../../../../components/buttons/IconButtons";
import {useNavigate} from "react-router-dom";
import CopySecretModal from "../../../Dashboard/Company/Employees/Modal/CopySecretModal";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 22 de 05 de 2026
 */

const SuccessResetPassword = ({t,email,secretModal, setSecretModal, secretKey, setSecretKey,setPassword}) => {
    const navigate = useNavigate();

    return (
        <GeneralStepBody t={t} title='success_reset_password'>
            <div className='d-flex flex-column text-center gap-3 mt-3 w-100 align-items-center'>
                <p className='fs-16px ibl-font-w-400 font-color-primary-600'>{email}</p>
                <p className='fs-16px ibl-font-w-400 font-color-shades-600'>{t('success_reset_description')}</p>
                <IconSuccessResetPassword width={300} height={300} />
                <div className='col-12 mt-3 p-0 w-100'>
                    <ButtonAction
                        id='btn_ov_forgot_password'
                        name={'go_to_login'}
                        className='btn-icon-add w-100'
                        onClick={() => {navigate(routes.home);}}
                        splitName={false}
                    />
                </div>
            </div>

            <CopySecretModal
                show={secretModal}
                setShow={setSecretModal}
                secret={secretKey}
                setSecret={setSecretKey}
                setData={setPassword}
                onHide={() => {}}
                closeText={"close"}
            />
        </GeneralStepBody>
    )
}

export default SuccessResetPassword
